export const FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=61587262282214&mibextid=wwXIfr";
export const INSTAGRAM_URL =
  "https://www.instagram.com/pailinabroad?igsh=MWRvMTdpcGI4aXYzOA%3D%3D&utm_source=qr";
export const LINE_URL = "https://line.me/R/ti/p/@084jscit";
